<div
  class="header-notification ion-text-center"
  [style.background-color]="backgroundColor">
  <p
    class="pre-wrap"
    [style.color]="textColor">
    {{ text }}
  </p>
</div>
